import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import { IconButton, Tooltip } from "@material-ui/core";
import Icon from "@jll/icon";
import styles from "./styles";
import {
  tableStyle,
  tableOptions,
  tableIcons,
} from "../../../../Component/Table/tableCommonStyles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

const AddressTable = ({ data, onRowViewClick, canRemoveAddress, onDelete }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.tableWrapper}>
      <MaterialTable
        style={tableStyle}
        icons={tableIcons}
        options={tableOptions}
        isLoading={false}
        data={data}
        localization={{
          header: {
            actions: t('labels.common.table.actions')
          },
          body: {
            emptyDataSourceMessage: t('labels.common.table.noRecordsFound'),
          }
        }}
        columns={[
          { title: t("labels.record.addresses.table.headers.addressType"), field: "address_type" },
          { title: t("labels.record.addresses.table.headers.addressLine1"), field: "address_line_1" },
          { title: t("labels.record.addresses.table.headers.city"), field: "city" },
          { title: t("labels.record.addresses.table.headers.postCode"), field: "postcode" },
          { title: t("labels.record.addresses.table.headers.country"), field: "country_name" },
          { title: t("labels.record.addresses.table.headers.jllRegion"), field: "jll_region" },
          { title: t("labels.record.addresses.table.headers.source"), field: "source" },
        ]}
        actions={[
          {
            icon: "ViewColumn",
            tooltip: t("labels.record.addresses.table.actions.viewContact"),
            onClick: (record) => onRowViewClick(record),
          },
          {
            icon: "DeleteColumn",
            tooltip: t("labels.record.addresses.table.actions.deleteContact"),
            onClick: (record) => onDelete(record),
          },
        ]}
        components={{
          Action: (props) => {
            switch (props.action.icon) {
              case "ViewColumn":
                return (
                  <Tooltip title={t("labels.record.addresses.table.actions.viewContact")} placement="bottom">
                    <IconButton
                      className={classes.actionIcons}
                      onClick={(event) => props.action.onClick(props.data)}
                    >
                      <Icon
                        className="fas fa-address-card"
                        style={{ fontSize: 16 }}
                      />
                    </IconButton>
                  </Tooltip>
                );
              case "DeleteColumn":
                if (canRemoveAddress) {
                  return (
                    <Tooltip title={t("labels.record.addresses.table.actions.deleteContact")} placement="bottom">
                      <div>
                        <IconButton
                          className={classes.actionIcons}
                          onClick={(event) => props.action.onClick(props.data)}
                          disabled={props.data.source !== "USER"}
                        >
                          <Icon
                            className="far fa-trash-alt"
                            style={{ fontSize: 16 }}
                          />
                        </IconButton>
                      </div>
                    </Tooltip>
                  );
                } else {
                  return null;
                }

              default:
                return null;
            }
          },
        }}
      />
    </div>
  );
};

export default AddressTable;
